import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../services/core/shared.service';
import { ProductService } from '../../services/product.service';
import * as _ from "lodash";
import { ConditionalExpr } from '@angular/compiler';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent implements OnInit {

  tags = [];
  colors = [];
  sizes = [];
  productsStock = [];
  products = [];
  pids=[];
  pageSize = 8;
  pageIndex = 0;    
  pageIds;
  filter = "";
  filterShow = false;

  constructor(
    private sharedService:SharedService,    
    private router: Router,
    private productService:ProductService) { 
    
  }

  ngOnInit() {
    
    //read products
    this.productService.readRandomIds().then(res=>{        
      res.forEach((e,i) =>{this.pids.push(e.id)});      
      this.pageIds = _.chunk(this.pids,this.pageSize);      
      this.readProductsByPage(this.pageIndex);
    },err=>{console.error(err);}).catch(err=>{console.error(err);});

    //read types
    this.productService.readTypes().then(res=>{    
      this.tags = res;      
    },err=>{console.error(err);}).catch(err=>{console.error(err);});

    //read colors
    this.productService.readColors().then(res=>{    
      this.colors = res;
    },err=>{console.error(err);}).catch(err=>{console.error(err);});

    //read sizes
    this.productService.readSizes().then(res=>{    
      this.sizes = res;
    },err=>{console.error(err);}).catch(err=>{console.error(err);});

    //on Filter data
    this.sharedService.sharedData.subscribe(data => {            
      if(data && data.name === 'searchText'){
        if (data && data.value && data.value != '') {
          //restart the origina list
          this.products = this.productsStock;  
          this.filter = data.value;              
          var filtered = _.map(this.products, function(o) {
            if (
              o.name.toLowerCase().indexOf(data.value.toLowerCase()) != -1 ||
              o.brand.toLowerCase().indexOf(data.value.toLowerCase()) != -1){
            return o;
              }
          });
          // Remove undefines from the array
          this.products = _.without(filtered, undefined)
          //console.log(this.products);
          this.filterShow = this.products.length == 0;
        }
        else{          
          this.products = this.productsStock;
        }
      }
    });

  }

  readProductsByPage(page){
    this.productService.readProductsByPage(this.pageIds[page]).then(res=>{    
      this.products = _.concat(this.products, res);      
      this.productsStock = this.products;      
    },err=>{console.error(err);}).catch(err=>{console.error(err);});
  }

  onScroll(){
    this.pageIndex++;
    //console.log("onScroll "+this.pageIndex);
    if(this.pageIndex < this.pageIds.length){      
      this.readProductsByPage(this.pageIndex);
    }
  }

  goDetails(p){
    this.sharedService.nextData({"name":"details","value":p});
    this.router.navigate(['details',p.id]);
  }

  displayMoney(amount){
    return amount ? "$ "+amount+" c/u":"";
  }
  formatUrl(url){
    if(url){
      return url.replace('.jpg','_253.jpg');
    }
    return "https://dummyimage.com/400.png/aaa/fff"
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/pages/store/store.component.ts